module.exports = __webpack_public_path__ + "static/media/virtual-assistant.c85a6917.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/ai/icons/virtual-assistant.gif
// module id = 3778
// module chunks = 0